module.exports = __webpack_public_path__ + "img/enging_room_pic05.6b307679.png";